import React, { Component } from "react";
import "./style.less";
import { getQuarter, quarterDateData } from "../../../utils/helper";
import { IconButton } from "@material-ui/core";
import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import Slider from "@material-ui/core/Slider";
import moment from "moment";

/**Quarterly Slider */
class QTRSlider extends Component {
	constructor(props) {
		super(props);
		const qtrMonth = props.startDate ? getQuarter(new Date(props.startDate)) : getQuarter(new Date().getFullYear());
		this.state = {
			startDate: props.startDate ? new Date(props.startDate) : new Date(),
			endDate: props.endDate ? new Date(props.endDate) : new Date(),
			QtrYear: props.qtrYear || moment().format("YYYY"),
			selectedQtr: qtrMonth,
		};
		this.quarterDateSelection(null, qtrMonth,  props.qtrYear || moment().format("YYYY"));
	}



	valueText = (value) => {
		return `${value} `;
	};

	/** Set quarter */
	setQtr = (type) => {
		let year;
		let startDate1;
		let endDate1;
		const { startDate, endDate, selectedQtr } = this.state

		if (type == "add") {
			year = moment(endDate)
				.subtract(1, "years")
				.format("YYYY");

			startDate1 = moment(startDate)
				.subtract(1, "years")
				.format("MM/DD/YYYY");
			endDate1 = moment(endDate)
				.subtract(1, "years")
				.format("MM/DD/YYYY");
		} else {
			year = moment(endDate)
				.add(1, "years")
				.format("YYYY");
			startDate1 = moment(startDate)
				.add(1, "years")
				.format("MM/DD/YYYY");
			endDate1 = moment(endDate)
				.add(1, "years")
				.format("MM/DD/YYYY");
			
		}

		if (moment().format("YYYY") < year) {
			return false;
		}

		this.setState(
			{
				// sliderYear: year,
				startDate: startDate1,
				endDate: endDate1,
				QtrYear: year,
			},
			() => {
				this.quarterDateSelection(null, selectedQtr, year);
			}
		);

		// this.state.isForReport == true && this.props.handleKey();
		// this.props.handelDateChangesSlideDate(startDate, endDate, "YTD");
	};

/**
 * Quarterly Date Selection
 * @param {*} event 
 * @param {*} value 
 */
	quarterDateSelection = (event, value, year) => {
		const { onChangeMonthRange } = this.props;
		const quaterData = quarterDateData(value, year);

		this.setState({ selectedQtr: value });
		onChangeMonthRange(moment(quaterData.startDate).format("MM/DD/YYYY"), moment(quaterData.endDate).format("MM/DD/YYYY"), value);
	};

	/**
	 * Render Quarterly Slider view
	 * @returns 
	 */
	render() {
		const { QtrYear, selectedQtr } = this.state;
		const quarterlyMarks = [
			{
				value: 1,
				label: "Q1",
			},
			{
				value: 2,
				label: "Q2",
			},
			{
				value: 3,
				label: "Q3",
			},
			{
				value: 4,
				label: "Q4",
			},
		];
		return (
			<div className={"row slider-container"}>
				<div style={{ width: "100%" }} key={"QTRDiv"}>
					<div className={"d-flex"} key={"QTRFlexDiv"}>
						<div style={{ width: "5%" }} key={"QTRLeft"}>
							<IconButton
								key={"QTRIconButtonLeft"}
								aria-label={"delete"}
								size={"small"}
								onClick={() => this.setQtr("add")}
							>
								<ArrowLeftIcon size={"small"} />
							</IconButton>
						</div>
						<div style={{ padding: "4px", width: "90%" }} key={"QTRSliderDiv"}>
							<Slider
								key={"QTRSlider"}
								track={false}
								// defaultValue={this.state.QtrRangeDefault}
								value={selectedQtr}
								getAriaValueText={this.valueText}
								aria-labelledby={"discrete-slider-custom"}
								step={1}
								min={1}
								max={4}
								valueLabelDisplay={"auto"}
								marks={quarterlyMarks}
								onChangeCommitted={(event, value) => {
									this.quarterDateSelection(event, value, QtrYear)
								}}
							/>
						</div>
						<div style={{ width: "10%" }} key={"QTRRightDiv"}>
							<IconButton
								key={"QTRIconButtonRight"}
								aria-label={"delete"}
								size={"small"}
								onClick={() => this.setQtr("Subtract")}
							>
								<ArrowRightIcon size={"small"} />
							</IconButton>
						</div>            
     </div>
					<div style={{ textAlign: "center", fontWeight: "bold" }} key={"QTRLabelDiv"}>
						{QtrYear}
					</div>
				</div>
			</div>
		);
	}
}

export default QTRSlider;
